import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import TextInput from '../form-fields/text-input';
import GenericForm from '../form-fields/generic-form';
import { login, CHANGE_AUTH } from '../../redux/modules/authentication';
import { errorPropTypes } from '../../util/proptype-utils';
import styles from './login.module.css';
import { getComponentTranslator } from '../../util/i18n';
import { Translate } from 'react-i18nify';

const translate = getComponentTranslator('login');

const form = reduxForm({
  form: 'login',
});

class Login extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    desiredPath: PropTypes.string,
    login: PropTypes.func,
    errors: errorPropTypes,
    message: PropTypes.string,
    loading: PropTypes.bool,
  };

  static formSpec = [
    {
      id: 'email',
      name: 'email',
      label: translate('email'),
      type: 'email',
      placeholder: 'you@yourdomain.com',
      component: TextInput,
    },
    {
      id: 'password',
      name: 'password',
      label: translate('password'),
      type: 'password',
      placeholder: '********',
      component: TextInput,
    },
  ];

  handleFormSubmit = (formProps) => {
    console.log('[LOGIN COMPONENT] Form submitted with data:', formProps);
    const { desiredPath } = this.props;
    if (desiredPath) {
      this.props.login(formProps, desiredPath);
    } else {
      this.props.login(formProps);
    }
  };

  render() {
    const { handleSubmit, errors, message, loading } = this.props;

    return (
      <div className={styles.loginContainer}>
        <div className={styles.leftSection}>
          <video 
            autoPlay 
            muted 
            loop 
            className={styles.backgroundVideo}
            playsInline
          >
            <source src="https://videos.pexels.com/video-files/3125907/3125907-sd_640_360_25fps.mp4" type="video/mp4" />
            Din webbläsare stöder inte video-taggen.
          </video>
          <h2>Everything you need,<br />to make anything you want.</h2>
          <p>Dozens of creative tools to ideate, generate<br />and edit content like never before.</p>
        </div>
        
        <div className={styles.authBox}>
          <h1 className={styles.h1}>Welcome to Healthweek</h1>
          <p className={styles.signUpText}>
            Don't have an account? <Link to="/register">Sign up for free</Link>
          </p>
          
          <GenericForm
            onSubmit={handleSubmit(this.handleFormSubmit)}
            errors={errors}
            message={message}
            formSpec={Login.formSpec}
            submitText="Log in"
            className={styles.form}
          />
          
          <div className={styles.divider}>OR</div>
          
          <div className={styles.socialLogin}>
            <button className={styles.socialButton}>
              <img 
                src="https://www.svgrepo.com/download/475656/google-color.svg"
                alt="Google" 
                className={styles.socialIcon} 
              />
              Log in with Google
            </button>
            <button className={styles.socialButton}>
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg" 
                alt="Apple" 
                className={styles.socialIcon} 
              />
              Log in with Apple
            </button>
          </div>
          
          <div className={styles.forget}>
            <Link to="/forgot-password">Forgot Password</Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  errors: authentication.errors[CHANGE_AUTH],
  message: authentication.messages[CHANGE_AUTH],
  loading: authentication.loading[CHANGE_AUTH],
  authenticated: authentication.authenticated,
  desiredPath: authentication.desiredPath,
});

export default connect(mapStateToProps, { login })(form(Login));
